module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#217730","theme_color":"#217730","display":"minimal-ui","icon":"src/assets/img/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"a3c575a7ff923f347988553f14df1339"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
